import _ from 'lodash';
import globalStore from '$$globalStore';
import app from '$$app';
import { createCommentsHelper } from './helpers';

function onTaskCommentCreated(event) {
  const tasksToUpdateMap = {};

  createCommentsHelper(event.data.comments);

  event.data.comments.forEach(comment => {
    const taskData = globalStore.getters['tasksModel/getTaskByGanttId'](comment.projectId, comment.taskId);

    if (!taskData) {
      return;
    }

    const hasComments = tasksToUpdateMap[comment.taskId] ? tasksToUpdateMap[comment.taskId].hasComments + 1 : +(taskData.hasComments || 0) + 1;

    tasksToUpdateMap[comment.taskId] = {
      id: +comment.taskId,
      gantt_id: +taskData.gantt_id,
      hasComments,
      newComments: 1,
    };
  });

  if (!_.isEmpty(tasksToUpdateMap)) {
    globalStore.commit('tasksModel/updateTasks', { tasks: Object.values(tasksToUpdateMap), fromGantt: false }, { root: true });
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    tasks: event.data.comments.map(i => i.taskId),
  });
}

export default onTaskCommentCreated;
